import type { HomepageSearchFilters } from '@rover/types/src/HomepageSearchFilters';
import { PetType } from '@rover/types/src/Pet';
import { ServiceFrequencyEnum } from '@rover/types/src/ServiceFrequency';
import { ServiceTypeSlug } from '@rover/types/src/ServiceType';

const homepageSearchFiltersFactory = (
  opts?: Partial<HomepageSearchFilters>
): HomepageSearchFilters => ({
  centerlat: undefined,
  centerlng: undefined,
  dateRange: {
    endDate: undefined,
    startDate: undefined,
  },
  frequency: ServiceFrequencyEnum.ONE_TIME,
  location: undefined,
  locationType: undefined,
  pet: [],
  petType: [PetType.DOG],
  rawLocationTypes: undefined,
  selectedDays: [],
  serviceTypeSlug: ServiceTypeSlug.OVERNIGHT_BOARDING,
  startDate: undefined,
  endDate: undefined,
  smallDogs: undefined,
  spacesRequired: undefined,
  mediumDogs: undefined,
  largeDogs: undefined,
  giantDogs: undefined,
  bypassInterstitial: undefined,
  dogCount: 0,
  catCount: 0,
  ...opts,
});

export default homepageSearchFiltersFactory;
